import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import InternalGate from './pages/InternalGate'
import ComingSoon from './pages/ComingSoon';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {import.meta.env.VITE_COMING_SOON === 'true' ? <ComingSoon /> : <InternalGate><App /></InternalGate>}
  </React.StrictMode>
);
